(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('PagarMeRecipientFormModalController', PagarMeRecipientFormModalController);

    function PagarMeRecipientFormModalController(recipient, $uibModalInstance) {

        var vm = this;

        vm.recipient = recipient;
        vm.isEdit = !!(recipient && recipient.recipientId);

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.onFormSaved = function () {
            $uibModalInstance.close('saved');
        };
    }
})();
